import * as actionTypes from "./actionTypes";
import * as types from "./types";

const initTaskListState: types.JobListState = {
    pending: false,
    jobs: {} as types.IDataJobList,
    error: null,
};

export const JobListReducer = (state = initTaskListState, action: types.JobListActions) => {
    switch (action.type) {
        case actionTypes.FETCH_JOB_LIST_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.FETCH_JOB_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                jobs: action.payload.jobs,
                error: null,
            };
        case actionTypes.FETCH_JOB_LIST_FAILURE:
            return {
                ...state,
                pending: false,
                jobs: {} as types.IDataJobList,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};
export default { JobListReducer };


